<div id="drawer-history-map" [ngClass]="{ 'map-aside-disabled': isHidden }">
  <!-- Barra de redimensionamiento arrastrable -->
  <div class="resize-handle"></div>

  <section class="full-content">
    <div
      class="content-map-aside content-map-aside_pr"
      [ngClass]="{ 'content-map-aside-hidden_pr': isHidden }"
    >
      <div class="title-aside-container">
        <div class="title">
          <button class="button-icon" (click)="hiddenHistoryMap()">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#arrowLeft"></use>
            </svg> -->
            <mat-icon size="20">west</mat-icon>
          </button>
          <p>Historial de vehículo</p>
        </div>
        <div class="tools">
          <button
            class="button-icon button-icon-close"
            (click)="destroyedHistoryMap()"
          >
            <!-- <svg width="24" height="24" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#close"></use>
            </svg> -->
            <mat-icon size="24">close</mat-icon>
          </button>
        </div>
      </div>
      <article class="content-history">
        <app-content-vehicle-history-drawer
          style="height: 100%"
          [dataHistoryDrawer]="dataHistoryDrawer"
          [mapResizeEvent]="mapResizeEvent"
        ></app-content-vehicle-history-drawer>
      </article>
    </div>
  </section>
</div>
